import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Container from "@mui/material/Container";

const OrgDashSkeleton = () => {

    return (
        <>
                <Grid container spacing={2} justify="center">
                    <Grid item size={12}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={120}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:8}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            animation="wave"
                            height={60}
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:4}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            animation="wave"
                            height={60}
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:3}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={150}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:3}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={150}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:3}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={150}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:3}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={150}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={180}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:3}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={300}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:3}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={300}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:3}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            animation="wave"
                            height={300}
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:3}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={300}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:5}}
                        />
                    </Grid>
                </Grid>
        </>


    );
};

export default OrgDashSkeleton;
